<script>
    import {createEventDispatcher} from "svelte";
    import NutritionalBar from "./NutritionalBar.svelte";
    import Price from "./Price.svelte";
    import PriceButton from "./PriceButton.svelte";
    import { t } from '../core/i18n/language-store';
    const dispatch = createEventDispatcher();

    export let record;
    export let publishConfig;
    export let tenantKey;

    let nutritionalOpen = false;
</script>
<style>

.record {
    width: 100%;
    display: flex;
    flex-direction: column;
}
.label {
    margin-bottom: 6px;
}
.description {
    font-family: Roboto, sans-serif;
    color: var(--secondary-font-color);
    font-size: 16px;
    white-space: pre-wrap;
}
.from {
    color: var(--secondary-font-color);
}
.weight {
    font-family: Roboto, sans-serif;
    color: var(--secondary-font-color);
}
.table {
    display: table;
}
.row {
    display: table-row;
}
.cell {
    display: table-cell;
    text-align: right;
    padding-left: .5em;
    padding-bottom: .5em;
}
.record-name {
    white-space: break-spaces;
    overflow-wrap: anywhere;
}
.record-name--long {
    font-size: 20px;
}
.description {
    overflow-wrap: anywhere;
}

</style>

{#if (!record.hidden)}

<div class="record desktop-col-3">


    {#if (record.label)}
        <div class="label">{ record.label }</div>
    {/if}

    <div class="flex-between">
        <div>
            <h4 class="record-name" class:record-name--long={record?.name?.length > 20} on:click={() => {nutritionalOpen = !nutritionalOpen;}}>
                { record.name }
            </h4>
            {#if (record.description)}
                <div class="description">
                    {record.description}
                </div>
            {/if}
        </div>
        <div class="table">
            <!--
            if mods: 'from' price
            if !mods & weights: list of prices
                if oldPrice: oldPrice
                if addToCard enabled: +
                if addToCard enabled & added: - {added} +
            -->

            {#each record.prices as p, i}

                <div class="row nowrap">

                    <span class="cell">
                        {#if p.weight}
                            <span class="weight">
                                { p.weight || '' }
                            </span>
                        {:else if (record.mods?.length > 0)}
                            <span class="from">
                                {$t('price.from')}
                            </span>
                        {/if}
                    </span>

                    <span class="cell">
                        {#if (record.prices.length === 1)}
                            <!-- single price -->
                            <Price record={record}
                                   priceItem={p}
                                   publishConfig={publishConfig}
                                   on:add={(e) => dispatch('addToCartWithPrice', {record, priceIndex: i})}
                                   on:remove={(e) => dispatch('removeFromCartWithPrice', {record, priceIndex: i})}>
                            </Price>
                        {:else}
                            <!-- multi price -->
                            <PriceButton record={record}
                                         priceItem={p}
                                         priceIndex={i}
                                         publishConfig={publishConfig}
                                         on:add={(e) => dispatch('addToCartWithPrice', {record, priceIndex: i})}
                                         on:remove={(e) => dispatch('removeFromCartWithPrice', {record, priceIndex: i})}>
                            </PriceButton>
                        {/if}
                    </span>

                </div>
            {/each}

        </div>
    </div>

    <NutritionalBar record={record}
                    open={nutritionalOpen}>
    </NutritionalBar>

</div>

{/if}
